import styled from 'styled-components';
import constants from '../../common/theme/constants';

export declare type ErrorSize = 'sm' | 'lg';

const { spacing, fontWeight, fontSize } = constants;

export const Text = styled.h3`
  font-weight: ${fontWeight.bold};
  margin-bottom: ${spacing.absolute.s}px;
`;

export const SubText = styled.p`
  font-size: ${fontSize.base}rem;
`;

export const SadCarImage = styled.img`
  width: 155px;
  height: 125px;
`;

export const Container = styled.div<{ size: ErrorSize }>`
  text-align: center;
  max-width: 320px;
  margin: 0 auto;
  padding-top: 15px;

  ${({ theme, size }) =>
    size === 'sm' &&
    `
      ${Text} {
        font-size: ${theme.headingFont.fontSize.p}rem;
      }

      ${SubText} {
        font-size: ${fontSize.p}rem;
      }

      ${SadCarImage} {
        width: 100px;
        height: 80px;
      }
  `}
`;
